<template>
  <!--
    DESCRIPTION AND CARE INSTRUCTIONS
    Below 640px (isMobile) product details render here as the full-width block.
    At >=640px they render as the in-context accordion in the PDP right column
    (ECOM-2770), so this block is mobile-only. This mirrors the MAD gating
    (isMobile), extending the in-context accordion down to the sm breakpoint so
    it no longer disappears in the 640–768px band. The recommendation carousels
    below always render regardless of viewport.
  -->
  <div v-if="isMobile" data-test-id="product-details-full-width">
    <AgsLazy placeholder-ratio="1/1" ssr class="-mx-5">
      <ProductDetailsNew :product="product" />
    </AgsLazy>
  </div>

  <AgsLazy placeholder-ratio="4/1" when-idle>
    <ProductRecommendations
      v-if="product.id && showShopTheLookReco"
      :token="OdoscopeRecommendationsToken.SHOP_THE_LOOK"
      :title="$t('recommendations.title.shop_the_look')"
      :product-id="props.product.id"
      :center-content="false"
      fetch-on-client
    />

    <ShopTheLookRecommendations :product-id="product.id" />

    <ProductRecommendations
      v-if="product.id"
      :token="OdoscopeRecommendationsToken.SIMILAR_PRODUCTS"
      :title="$t('recommendations.title.similar_products')"
      :product-id="props.product.id"
      :center-content="false"
      fetch-on-client
    />

    <LastSeenProductsRecommendations :product-id="product.id" />

    <ProductRecommendations
      v-if="deepestCategoryId !== undefined"
      :token="OdoscopeRecommendationsToken.TOPSELLER"
      :title="$t('recommendations.title.topseller')"
      :category-id="deepestCategoryId"
      :center-content="false"
      fetch-on-client
    />
  </AgsLazy>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import { getDeepestCategory } from '~/composables'
import ProductDetailsNew from '~/components/product/ProductDetailsNew.vue'
import { OdoscopeRecommendationsToken } from '#layers/base/constants/recommendations'
import LastSeenProductsRecommendations from '#layers/base/components/product/LastSeenProductsRecommendations.vue'
import ShopTheLookRecommendations from '~/components/product/ShopTheLookRecommendations.vue'
import ProductRecommendations from '~/components/product/ProductRecommendations.vue'
import { useDeviceType } from '~/composables/useDeviceType'

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
})

const { isMobile } = useDeviceType()

const showShopTheLookReco = false
const deepestCategory = getDeepestCategory(props.product.categories)
const deepestCategoryId = deepestCategory?.categoryId
</script>
